export class CertificationPayment {
    personId: number;
    payerName: string;
    paymentType: string; 
    Address: string;
    City: string;
    State: string;
    countryId: string;
    Zip: string;
    TotalCost: number; 
    salesTax: number;
    cardNumber: string;
    expirationDate: string;
    cardCode: string;
    dataDescriptor = null;
    dataValue = null;
}
